import { useState, useEffect } from "react";

const LINKS = [
  { label: "About", href: "#about" },
  { label: "Services", href: "#services" },
  { label: "Contact", href: "#contact" },
];

export default function Masthead() {
  const [slim, setSlim] = useState(false);

  useEffect(() => {
    const onScroll = () => setSlim(window.scrollY > 380);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (e, href) => {
    e.preventDefault();
    window.__lenis?.scrollTo(href, { offset: -70, duration: 1.2 });
  };

  return (
    <>
      <div
        data-testid="site-nav"
        className={`fixed top-0 inset-x-0 z-50 bg-white/90 backdrop-blur-md border-b border-[#E5E5DE] transition-transform duration-500 ${
          slim ? "translate-y-0" : "-translate-y-full"
        }`}
      >
        <div className="max-w-[1200px] mx-auto flex items-center justify-between px-6 h-14">
          <a href="#top" onClick={(e) => go(e, "#top")} data-testid="nav-logo" className="flex items-center">
            <img src="/logo.webp" alt="eProcure Inc." className="h-7 w-auto" />
          </a>
          <nav className="hidden md:flex items-center gap-10">
            {LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={(e) => go(e, l.href)}
                data-testid={`nav-link-${l.label.toLowerCase()}`}
                className="text-[11px] font-semibold tracking-[0.3em] uppercase text-[#16180F]/70 hover:text-[#4C8C1E] transition-colors duration-300"
              >
                {l.label}
              </a>
            ))}
          </nav>
        </div>
      </div>

      <header className="border-b border-[#E5E5DE]">
        <div className="max-w-[1200px] mx-auto flex items-center justify-between px-6 py-2.5 border-b border-[#E5E5DE]">
          <p className="hidden md:block text-[11px] tracking-[0.25em] uppercase text-[#6F6F63]">
            B2B Marketplace &amp; Consulting — Mississauga, ON
          </p>
          <a
            href="#contact"
            onClick={(e) => go(e, "#contact")}
            data-testid="masthead-utility-contact"
            className="text-[11px] tracking-[0.25em] uppercase text-[#6F6F63] hover:text-[#16180F] transition-colors duration-300"
          >
            Reach the Owner
          </a>
        </div>

        <div className="py-5 md:py-6 text-center px-6">
          <a href="#top" onClick={(e) => go(e, "#top")} data-testid="masthead-wordmark" className="inline-block leading-none">
            <img src="/logo.webp" alt="eProcure Inc." className="h-9 md:h-10 w-auto mx-auto block" />
          </a>
        </div>

        <nav className="border-t border-[#E5E5DE] overflow-x-auto">
          <div className="max-w-[1200px] mx-auto flex justify-center gap-10 md:gap-16 px-6 py-4 min-w-max">
            {LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={(e) => go(e, l.href)}
                data-testid={`masthead-link-${l.label.toLowerCase()}`}
                className="text-[11px] font-semibold tracking-[0.35em] uppercase text-[#16180F]/80 hover:text-[#4C8C1E] transition-colors duration-300"
              >
                {l.label}
              </a>
            ))}
          </div>
        </nav>
      </header>
    </>
  );
}
